module.exports = __webpack_public_path__ + "static/media/logo-black-friday-white.3d86bf0b.png";